export enum UserRole {
  SYSTEM_ADMIN = "SYSTEM_ADMIN",
  ACCOUNT_ADMIN = "ACCOUNT_ADMIN",
  USER = "USER",
  SUPPORT = "SUPPORT",
}
